import { useRef } from "react"
import useResource from "./useResource"
import { NUMERIC_FIELD_KINDS } from "web/constants"
import usePreloadSWRCache from "./usePreloadSWRCache"

const LIST_IDENTITY = [
  0, // viewType
  1, // viewId
]

export default function useViewComparison({
  view: {
    id,
    type,
    fields,
    comparison,
    swrKey,
    currency,
    area_unit,
    length_unit,
    distance_unit,
  },
}) {
  const lastFetchKey = useRef()

  const viewURL = `views/${id}/comparison`
  const viewGroupURL = `view_groups/${id}/comparison`
  const path = type === "group" ? viewGroupURL : viewURL

  const viewNumericFieldsKey = fields
    .filter((vf) => NUMERIC_FIELD_KINDS.includes(vf.field.kind))
    .map((vf) => vf.field.id)
    .join("/")

  const fetchKey = [
    type,
    id,
    viewNumericFieldsKey,
    currency,
    area_unit,
    length_unit,
    distance_unit,
    comparison.reference_subject_id,
    ...(comparison.selected_subject_ids || []),
  ]

  usePreloadSWRCache(LIST_IDENTITY, lastFetchKey.current, fetchKey)

  lastFetchKey.current = fetchKey

  return useResource({
    key: fetchKey,
    parentKeys: [swrKey],
    url: path,
  })
}
